<template>
  <div>
<lk-row class="mb8">
<lk-table border :columns='cols' :data='tableData'></lk-table>
</lk-row>
<!-- <lk-row>
  <lk-page></lk-page>
</lk-row> -->
  </div>
</template>

<script>
import Uploader from '../Uploader.vue';
import sale from '../../services/sale';
import utils from '../../libs/utils';

export default {
  name: 'medicineInfo',
  components: { },
  props: {
    value: {

    },
    id: {},
    able: {},
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  data() {
    return {
      patientRebuyList: [],
      tableData: [],
      validate: {},
      cols: [
        { title: '序号', type: 'index', minWidth: 60 },
        { title: '通用名', key: 'goodsInfoVoApprovedDrugName', minWidth: 110 },

        { title: '商品名', key: 'goodsInfoVoGoodsName', minWidth: 110 },

        { title: '规格', key: 'goodsInfoVoSpec', minWidth: 110 },
        { title: '数量', key: 'saleOrderDetailGoodsCount', minWidth: 110 },
        { title: '包装单位', key: 'saleOrderDetailGoodsUnit', minWidth: 110 },
        { title: '用法用量', key: 'saleUsageUsageDosage', minWidth: 110 },
        { title: '开始用药时间', key: 'saleUsageUsageStartTime', minWidth: 110 },
        { title: '用药周期', key: 'saleUsageMedicationCycle', minWidth: 110 },

        { title: '计划复购日期', key: 'patientRebuyPlanRebuyTime', minWidth: 110 },
        {
          title: '回访复购1',
          key: 'patientRebuyRecall1',
          minWidth: 110,
          render: this.judgeRender,
        },
        {
          title: '未复购原因1',
          key: 'patientRebuyReason1',
          minWidth: 210,
          render: this.reasonRender,
        },
        {
          title: '回访备注1',
          key: 'patientRebuyRemark1',
          minWidth: 210,
          tooltip: true,
          render: this.remarkRender,
        },
        {
          title: '回访复购2',
          key: 'patientRebuyRecall2',
          minWidth: 110,
          render: this.judgeRender,
        },
        {
          title: '未复购原因2',
          key: 'patientRebuyReason2',
          minWidth: 210,
          render: this.reasonRender,
        },
        {
          title: '回访备注2',
          key: 'patientRebuyRemark2',
          minWidth: 210,
          tooltip: true,
          render: this.remarkRender,
        },
        {
          title: '回访复购3',
          key: 'patientRebuyRecall3',
          minWidth: 110,
          render: this.judgeRender,
        },
        {
          title: '未复购原因3',
          key: 'patientRebuyReason3',
          minWidth: 210,
          render: this.reasonRender,
        },
        {
          title: '回访备注3',
          key: 'patientRebuyRemark3',
          minWidth: 210,
          tooltip: true,
          render: this.remarkRender,
        },
        {
          title: '是否复购',
          key: 'patientRebuyIsRebuy',
          minWidth: 110,
          render: (h, { row }) => {
            const judgeArr = ['', '是', '否'];
            // console.log(row);

            return h('span', judgeArr[row.patientRebuyIsRebuy]);
          },
        },
        { title: '实际用药周期', key: 'patientRebuyRealUsageCycle', minWidth: 110 },
        { title: '当前状态', key: 'patientRebuyStatusStr', minWidth: 110 },
        { title: '应复购次数', key: 'patientRebuyShouldNum', minWidth: 110 },
        { title: '准时复购次数', key: 'patientRebuyOnTimeNumInt', minWidth: 110 },
        { title: '延迟复购次数', key: 'patientRebuyDelayNumInt', minWidth: 110 },
        { title: '提前复购次数', key: 'patientRebuyEarlyNumInt', minWidth: 110 },

        { title: '生产企业', key: 'saleOrderDetailManufacturer', minWidth: 110 },
        { title: '批准文号/注册证号', key: 'goodsInfoVoApprovalCode', minWidth: 160 },
        { title: '购药门店', key: 'saleOrderStoreName', minWidth: 110 },
        { title: '购药日期', key: 'saleOrderCreateTime', minWidth: 110 },
        { title: '处方医院', key: 'salePrescriptionPrescriptionHospital', minWidth: 110 },
        { title: '处方医生', key: 'salePrescriptionPrescriptionDoctor', minWidth: 110 },

        {
          title: '处方图片',
          minWidth: 210,
          render: (h, { row }) => h(Uploader,
            {
              props: {
                url: row.salePrescriptionPicUrl,
                maxSize: 20,
                // able: true,
              },
            }),
        },
        { title: '医保类型', key: 'insuranceType', minWidth: 110 },
        { title: '订单类型', key: 'saleOrderTypeName', minWidth: 110 },
      ],
    };
  },
  methods: {
    remarkRender(h, params) {
      const { index, column, row } = params;
      if (this.able && row.patientRebuyId) {
        return h('lk-input', {
          props: {
            type: 'textarea',
            rows: 3,
            maxlength: 200,
            value: row[column.key],
          },
          on: {
            'on-change': (val) => {
              const keyName = column.key.replace('patientRebuy', '').toLowerCase();
              console.log(keyName);
              this.patientRebuyList[index][keyName] = val.target.value || '';
            },
          },
        });
      }
      if (row[column.key].length > 56) {
        return h('div', {
          style: {
            height: '100px',
            overflow: 'scroll',
          },
          props: {
            value: row[column.key],
          },
        }, row[column.key]);
      }
      return h('span', {
        props: {
          value: row[column.key],
        },
      }, row[column.key]);
    },
    judgeRender(h, params) {
      const { index, column, row } = params;
      const judgeArr = ['是', '否'];
      const options = judgeArr.map((item, i) => h('lk-option', {
        props: {
          value: i + 1,
        },
      }, item));
      if (this.able && row.patientRebuyId) {
        return h('lk-select', {
          props: {
            value: row[column.key],
            transfer: true,
            clearable: true,
          },

          on: {
            'on-change': (val) => {
              const keyName = column.key.replace('patientRebuy', '').toLowerCase();
              console.log(keyName);

              this.patientRebuyList[index][keyName] = val || '';
            },
          },
        }, options);
      }
      return h('span', {}, judgeArr[row[column.key] - 1]);
    },


    reasonRender(h, params) {
      const { index, row, column } = params;
      // this.patientRebuyList[index].patientRebuy.id = {
      //   patientRebuy: {
      //     id: row.patientRebuyId,
      //   },
      // };
      // const reasonArr = this.$store.getters.getNoRebuyReasonStr.map(item => item);
      // [
      //   '购买渠道改变',
      //   '已去世',
      //   '不愿随访',
      //   '个性化疗程',
      //   '疾病进展, 医生建议停药或换药',
      //   '不良反应严重, 医生建议停药',
      //   '经济负担大',
      //   '已治愈, 医生建议停药',
      //   '诊疗时间延误',
      //   '其他药房领取赠药',
      //   '本门店领取赠药，未使用ERP系统'];
      const options = this.$store.getters.getNoRebuyReason.map((item, i) => h('lk-option', {
        props: {
          value: item.value,
        },
      }, item.title));
      if (this.able && row.patientRebuyId) {
        return h('lk-select', {
          props: {
            transfer: true,
            value: row[column.key],
            clearable: true,
          },
          on: {
            'on-change': (val) => {
              const keyName = column.key.replace('patientRebuy', '').toLowerCase();
              // console.log(keyName);

              this.patientRebuyList[index][keyName] = val || '';
            },
          },
        }, options);
      }
      return h('span', this.$store.getters.getNoRebuyReasonStr(row[column.key]));
    },
    submitData() {
      return new Promise((resolve) => {
        resolve(this.patientRebuyList);
      });
    },
    getPatientSaleInfo(id) {
      sale.getPatientSaleInfo({
        patientId: id,

      }).then((res) => {
        if (res.data.status === 200) {
          const { data } = res.data;
          this.tableData = [];
          data && data.forEach((item) => {
            const result = {};
            const { patientRebuy } = item;
            this.patientRebuyList.push(patientRebuy);// 复制提交数据，特殊处理表格
            utils.exchangeTable(item, result);
            result.saleOrderCreateTime = utils.formatDate(result.saleOrderCreateTime);
            result.patientRebuyPlanRebuyTime = utils.formatDate(result.patientRebuyPlanRebuyTime);
            result.saleUsageUsageStartTime = utils.formatDate(result.saleUsageUsageStartTime);
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.getPatientSaleInfo(this.id);
  },

};
</script>

<style lang="less" scoped>

</style>
